"use client";

import React from "react";
import styled from "styled-components";
import { Text } from "@lmn/design-system";
import { WhitelabelConfig } from "@/whitelabel/helpers/types";
import CustomerSupportBanner from "@/components/UI/CustomerSupportBanner/CustomerSupportBanner";
import FilterChips from "@/components/Stateful/FilterChips/FilterChips";
import IconArrowDown from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconArrowDown.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 0;
  gap: 1rem;
  text-align: center;
`;

const ArrowDivider = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 1rem 0 0.5rem 0;
  border-top: 1px solid
    ${({ theme }) => theme.kallisto.color.icon.static.iconDisabled};


  svg {
    margin-top: -0.75rem;
    padding: 0.25rem;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 1px solid
      ${({ theme }) => theme.kallisto.color.icon.static.iconDisabled};
    background: ${({ theme }) =>
  theme.kallisto.color.background.static.backgroundPage};
    fill: ${({ theme }) => theme.kallisto.color.icon.static.iconDisabled};
  }
`;

interface NoResultsFoundProps {
  filtersPresentText?: React.ReactNode;
  noFiltersText?: React.ReactNode;
  alternativeOffersPresent?: boolean;
  WlConfig?: WhitelabelConfig;
  showFilterChips?: boolean;
}

const defaultFiltersPresentText =
  "Versuchen Sie, Ihre Suchkriterien anzupassen oder gesetzte Filter zu entfernen, um Ergebnisse zu erhalten.";

const defaultNoFiltersText = "Versuchen Sie, Ihre Suchkriterien anzupassen oder gesetzte Filter zu entfernen, um Ergebnisse zu erhalten. Alternativ haben wir hier unsere beliebtesten Angebote für Sie zusammengestellt – vielleicht ist ja das Richtige dabei?"

export default function NoResultsFound({
  filtersPresentText = defaultFiltersPresentText,
  noFiltersText = defaultNoFiltersText,
  alternativeOffersPresent = true,
  WlConfig,
  showFilterChips = false,
}: NoResultsFoundProps) {
  return (
    <Container>
      <Text variant="Title2">
        Leider konnten wir kein passendes Angebot für Sie finden.
      </Text>

      {showFilterChips && <FilterChips itemsCentered />}

      {WlConfig?.supportBannerNumber && (
        <CustomerSupportBanner
          title={WlConfig.supportBannerNoResultHeader}
          text={WlConfig.supportBannerNoResultCopy}
          phoneNumber={WlConfig.supportBannerNumber}
          timeSchedulePrefix={WlConfig.supportBannerTimeSchedulePrefix}
          timeSchedule={WlConfig.supportBannerNoResultTimeSchedule}
          timeSchedule2={WlConfig.supportBannerNoResultTimeSchedule2}
        />
      )}

      <Text variant="Body">
        {showFilterChips ? filtersPresentText : noFiltersText}
      </Text>

      {alternativeOffersPresent && (
        <ArrowDivider>
          <IconArrowDown />
        </ArrowDivider>
      )}
    </Container>
  );
}
